import { useEffect, useRef } from "react";
import { AlertTriangle } from "lucide-react";

export const ErrorSummary = ({ errors, fields, title = "Correggi i seguenti errori:" }) => {
    const ref = useRef(null);
    const entries = Object.entries(errors || {});
    useEffect(() => {
        if (entries.length) ref.current?.focus();
    }, [errors]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!entries.length) return null;
    const labelOf = (k) => fields?.find((f) => f.key === k)?.label || k;
    return (
        <div ref={ref} tabIndex={-1} role="alert" className="rounded-lg border-2 border-edi-error bg-edi-error-bg p-4 text-edi-text" data-testid="form-error-summary">
            <p className="font-bold flex items-center gap-2 text-edi-error"><AlertTriangle aria-hidden="true" size={18} /> {title}</p>
            <ul className="mt-2 list-disc pl-6 space-y-1">
                {entries.map(([k, msg]) => (
                    <li key={k}><a href={`#field-${k}`} className="underline">{labelOf(k)}: {msg}</a></li>
                ))}
            </ul>
        </div>
    );
};

export const Notice = ({ kind = "info", children, testId, role = "status" }) => {
    const styles = {
        info: "border-edi-dark bg-edi-surface",
        success: "border-edi-success bg-edi-success-bg",
        error: "border-edi-error bg-edi-error-bg",
        warning: "border-edi-lime bg-edi-warning-bg text-edi-warning-text",
    };
    return (
        <div role={role} className={`rounded-lg border-l-4 p-4 ${styles[kind]}`} data-testid={testId}>
            {children}
        </div>
    );
};
